import { dateFunc } from "@/components/Functions/dateFunc";
import {
  useGetClaimSummaryViewApiDataQuery,
  useGetcreditorContactsApiDataQuery,
  useGetcreditorContactsDataApiDataQuery,
} from "@/services/claimSummary/caseSummaryReducer";
import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifChip,
  MotifLabel,
  MotifIconButton,
  MotifSelect,
  MotifOption,
} from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EditContactFields } from "./editContactFields";
import { useTranslation } from "react-i18next";
import { skipToken } from "@reduxjs/toolkit/query";
import { getCommonCopyImg } from "@/components/Images/CommonImages";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
export const CreditorContactsEdit = ({
  formSubmitted,
  resolvedStatus,
  setSelectedClaimContactId,
}: any) => {
  const [contactId, setContactId] = useState("");
  const [edit, setEdit] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [notificationVisible, setNotificationVisible] = useState(false);
  const parameter = useParams();
  const { data } = useGetClaimSummaryViewApiDataQuery(parameter?.claimId);
  const { t } = useTranslation();
  const { data: getCreditorData } = useGetcreditorContactsApiDataQuery(
    data.claimSummary?.creditorId || ""
  );
  const { data: getCreditorApiData } = useGetcreditorContactsDataApiDataQuery({
    contactId: contactId || skipToken,
    creditorId: data.claimSummary?.creditorId,
  });
  useEffect(() => {
    setContactId(data?.creditorContact?.contactId);
    setSelectedClaimContactId(data?.creditorContact?.contactId);
    // eslint-disable-next-line
  }, [data?.creditorContact?.contactId !== ""]);

  const copiedToClipBoard = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setNotificationVisible(false);
    setNotification({
      ...notification,
      show: false,
      message: "",
      type: "success",
    });
    if (getCreditorApiData && Object.keys(getCreditorApiData).length) {
      const namePart = [
        getCreditorApiData.firstName,
        getCreditorApiData.lastName,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      const addressPart = [
        getCreditorApiData.address1,
        getCreditorApiData.address2,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      const cityStatePostalPart = [
        getCreditorApiData.city,
        getCreditorApiData.provinceState,
        getCreditorApiData.postalCode,
      ]
        .filter(Boolean)
        .join(", ")
        .trim();
      const addressParts = [namePart, addressPart, cityStatePostalPart];
      const formattedAddress = addressParts
        .filter((part) => part && part.trim() !== "")
        .join("\n");
      navigator.clipboard
        .writeText(formattedAddress)
        .then(() => {
          setNotificationVisible(true);
          setNotification({
            ...notification,
            show: true,
            message: t("global.globalNotifications.copiedToClipboard"),
            type: "success",
          });
        })
        .catch((err) => {
          setNotificationVisible(true);
          setNotification({
            ...notification,
            show: true,
            message: t("global.globalNotifications.copiedToClipboardError"),
            type: "error",
          });
        });
    }
  };
  return (
    <>
      {notificationVisible && (
        <NotificationGrid
          show={notification.show}
          message={notification.message}
          type={notification.type}
        />
      )}
      <div className="motif-container case-summary-form pad-v-20">
        <div className="motif-body1-default-regular page-title">
          {t(
            "pages.claims.claimsEditTab.formLabelDetails.editCreditorContactsTitle"
          )}{" "}
        </div>
        <div className="motif-body2-default-regular page-description">
          {t(
            "pages.claims.claimsEditTab.formLabelDetails.editCreditorContactsDescription"
          )}
        </div>
      </div>
      <div
        className="motif-container main-container ccwp_claim_summary_form ccwp_claim_summary_white_accordian pad-t-20 mar-b-20 pad-b-20"
        style={{ position: "relative" }}
      >
        <div className="ccwp_claim_creditor_contacts_edit">
          <MotifLabel id="select-label" className="mar-b-10 required-field">
            {t(
              "pages.claims.claimsEditTab.formLabelDetails.selectClaimContact"
            )}
          </MotifLabel>
          <MotifSelect
            onChange={(e: any) => {
              setContactId(e);
              setSelectedClaimContactId(e);
            }}
            className="mar-b-20 motif-col-lg-7"
            value={
              getCreditorData && getCreditorData.length > 0 ? contactId : ""
            }
          >
            <MotifOption disabled>
              {t(
                "pages.claims.claimsEditTab.formLabelDetails.selectClaimContact"
              )}
            </MotifOption>
            {getCreditorData && getCreditorData.length > 0
              ? getCreditorData?.map((items: any) => {
                  return (
                    <MotifOption
                      value={items.contactId}
                      selected={
                        items.contactId === data?.creditorContact?.contactId
                      }
                      title={items.firstName + " " + items.lastName}
                    >
                      {items.firstName + " " + items.lastName}
                    </MotifOption>
                  );
                })
              : []}
          </MotifSelect>
          {
            !edit && (
              <MotifAccordion
                onClose={function Ua() {}}
                onOpen={function Ua() {}}
                style={{
                  flex: "1",
                }}
                alignIconRight={true}
                useChevronIcon={true}
                className="mar-b-20"
              >
                <MotifAccordionTrigger>
                  <div className="ccwp_claim_summary_white">
                    <ul>
                      <li>
                        <label>
                          {t("pages.claims.commonFieldLabels.name")}
                        </label>
                        <p className="text-bold-underline">
                          {getCreditorApiData?.firstName}{" "}
                          {getCreditorApiData?.lastName}
                        </p>
                      </li>
                      <li>
                        {getCreditorApiData?.isPrimaryContact === true && (
                          <MotifChip dotSide="left">
                            {t("pages.claims.commonFieldLabels.primary")}
                          </MotifChip>
                        )}
                      </li>
                      <li onClick={() => setEdit(true)}>
                        {/* <MotifIcon
                        iconFunction={IconoirEditPencil}
                        stroke="#656579"
                        strokeWidth="2"
                        size="20"
                      /> */}
                      </li>
                    </ul>
                    <div
                      style={{
                        position: "absolute",
                        right: "76px",
                        top: "130px",
                      }}
                    >
                      <CommonTooltipWrapper
                        tooltipTitle={t("global.globalActions.copyToClipboard")}
                      >
                        <MotifIconButton
                          size="small"
                          onClick={copiedToClipBoard}
                          type="button"
                        >
                          {getCommonCopyImg()}
                        </MotifIconButton>
                      </CommonTooltipWrapper>
                    </div>
                  </div>
                </MotifAccordionTrigger>
                <MotifAccordionContent>
                  <ul className="ccwp_claim_summary_details">
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.firstName")}
                      </label>
                      <p>
                        {!getCreditorApiData?.firstName
                          ? "-"
                          : getCreditorApiData?.firstName}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.lastName")}
                      </label>
                      <p>
                        {!getCreditorApiData?.lastName
                          ? "-"
                          : getCreditorApiData?.lastName}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.businessName")}
                      </label>
                      <p>
                        {!getCreditorApiData?.businessName
                          ? "-"
                          : getCreditorApiData?.businessName}
                      </p>
                    </li>
                    <li>
                      <label>{t("pages.claims.commonFieldLabels.phone")}</label>
                      <p>
                        {!getCreditorApiData?.phone
                          ? "-"
                          : getCreditorApiData?.phone}
                      </p>
                    </li>
                    <li>
                      <label>{t("pages.claims.commonFieldLabels.email")}</label>
                      <p>
                        {!getCreditorApiData?.email
                          ? "-"
                          : getCreditorApiData?.email}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.address1")}
                      </label>
                      <p>
                        {!getCreditorApiData?.address1
                          ? "-"
                          : getCreditorApiData?.address1}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.address2")}
                      </label>
                      <p>
                        {!getCreditorApiData?.address2
                          ? "-"
                          : getCreditorApiData?.address2}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.country")}
                      </label>
                      <p>
                        {!getCreditorApiData?.country
                          ? "-"
                          : getCreditorApiData?.country}
                      </p>
                    </li>

                    <li>
                      <label>{t("pages.claims.commonFieldLabels.city")}</label>
                      <p>
                        {!getCreditorApiData?.city
                          ? "-"
                          : getCreditorApiData?.city}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.provincestate")}
                      </label>
                      <p>
                        {!getCreditorApiData?.provinceState &&
                        !getCreditorApiData?.provinceStateCode
                          ? "-"
                          : getCreditorApiData?.provinceStateCode ||
                            getCreditorApiData?.provinceState}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.postalCode")}
                      </label>
                      <p>
                        {!getCreditorApiData?.postalCode
                          ? "-"
                          : getCreditorApiData?.postalCode}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.lastUpdatedOn")}
                      </label>
                      <p>
                        {!getCreditorApiData?.updatedOn
                          ? "-"
                          : dateFunc(getCreditorApiData?.updatedOn)
                              .formattedDateOnly}
                      </p>
                    </li>
                    <li>
                      <label>
                        {t("pages.claims.commonFieldLabels.lastUpdatedBy")}
                      </label>
                      <p>
                        {!getCreditorApiData?.updatedBy
                          ? "-"
                          : getCreditorApiData?.updatedBy}
                      </p>
                    </li>
                  </ul>
                </MotifAccordionContent>
              </MotifAccordion>
            )}
          {edit && (
            <EditContactFields
              claiSummaryData={data}
              getCreditorApiData={getCreditorApiData}
              formSubmitted={formSubmitted}
            />
          )}
        </div>
      </div>
    </>
  );
};
